// extracted by mini-css-extract-plugin
module.exports = {"container":"_1dJHxl0Yx01x5pm1wbusTp"};